import React from 'react';
import {
  StyleSheet,
  View,
  Text,
  TextInput,
  ScrollView,
} from './components/base_components';

import { BusyComponent, BusyOverlay } from './components/busy_component';
import Header from './components/header';
import TextButton from './components/buttons/text_button';
import VolumeSelect from './components/volume_select';

import FuseFileStore from './stores/fuse_file_store';

const styles = StyleSheet.create({
  fileReportScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  scroller: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
  },
  scrollInner: {
    paddingLeft: '3em',
    paddingRight: '3em',
    paddingTop: '3em',
    paddingBottom: '5em',
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    overflowY: 'scroll',
  },
  title: {
    marginTop: '1em',
    marginBottom: '0.5em',
    fontSize: '1.3em',
    fontWeight: 'bold',
  },
  input: {
    marginTop: '0.5em',
    width: '20em',
    height: '3em',
    paddingLeft: '1em',
    paddingRight: '1em',
    color: 'black',
    backgroundColor: '#ccc',
    borderRadius: '0.5em',
  },
  button: {
    marginTop: '1em',
    height: '3em',
  },
  report: {
    marginTop: '1em',
    alignSelf: 'stretch',
    flexDirection: 'column',
  },
  headerLine: {
    height: '2.5em',
    marginBottom: '0.5em',
    backgroundColor: '#ccc',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  reportLine: {
    height: '2em',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    ':hover': {
      backgroundColor: 'lightblue',
    },
  },
  even: {
    backgroundColor: '#eee',
  },
  odd: {
    backgroundColor: 'white',
  },
  date: {
    paddingLeft: '1em',
    width: '8em',
  },
  deviceName: {
    paddingLeft: '1em',
    width: '15em',
  },
  total: {
    paddingLeft: '1em',
    width: '10em',
  },
});

type Props = {};
type State = {
  volume_id: string;
  start_date: string;
  report_lines: any;
};

export default class FileReportScreen extends BusyComponent<Props, State> {
  state = {
    volume_id: '',
    start_date: '',
    file_report_lines: null,
  };

  _onGetPress = () => {
    const { volume_id, start_date } = this.state;
    if (volume_id && start_date && this.setBusy()) {
      const opts = {
        volume_id,
        start_date,
      };
      FuseFileStore.fetchReport(opts, (err, file_report_lines) => {
        this.clearBusy();
        if (err) {
          window.alert('Failed to fetch report, please try again.');
        } else {
          this.setState({ file_report_lines });
        }
      });
    }
  };

  render() {
    const { volume_id, start_date, file_report_lines } = this.state;

    let report = null;
    if (file_report_lines && file_report_lines.length > 0) {
      const lines = file_report_lines.map((line, i) => (
        <ReportLine key={i} line={line} odd={i % 2 === 0} />
      ));
      report = (
        <View style={styles.report}>
          <Text style={styles.headerLine}>
            <Text style={styles.date}>Date</Text>
            <Text style={styles.deviceName}>Device Name</Text>
            <Text style={styles.total}>Changed Files</Text>
            <Text style={styles.total}>Total Changes</Text>
          </Text>
          {lines}
        </View>
      );
    } else if (file_report_lines) {
      report = (
        <View style={styles.report}>
          <Text style={styles.text}>No usage found.</Text>
        </View>
      );
    }
    return (
      <View style={styles.fileReportScreen}>
        <ScrollView
          style={styles.scroller}
          contentContainerStyle={styles.scrollInner}
        >
          <Header />
          <Line />
          <Text style={styles.title}>Project Drive Usage Report</Text>
          <VolumeSelect
            onlyProject={true}
            value={volume_id}
            onChange={(volume_id) => this.setState({ volume_id })}
          />
          <TextInput
            style={styles.input}
            value={start_date}
            type='date'
            placeholder='Start Date'
            onChangeText={(start_date) => this.setState({ start_date })}
          />
          <TextButton
            style={styles.button}
            text='Get Report'
            onPress={this._onGetPress}
          />
          {report}
        </ScrollView>
        <BusyOverlay isBusy={this.state.is_busy} />
      </View>
    );
  }
}

function Line() {
  return <View style={styles.line} />;
}
function ReportLine(props) {
  const { line, odd } = props;
  const { date, device_name, changed_files, total_changes } = line;
  const extra = odd ? styles.odd : styles.even;
  return (
    <View style={[styles.reportLine, extra]}>
      <Text style={styles.date}>{date}</Text>
      <Text style={styles.deviceName}>{device_name}</Text>
      <Text style={styles.total}>{changed_files}</Text>
      <Text style={styles.total}>{total_changes}</Text>
    </View>
  );
}
